<script setup lang="ts">
import { nextTick, ref, watch } from 'vue'
import { useResultModalStore } from '@/stores/resultModal'

const resultModal = useResultModalStore()
const closeBtnRef = ref<HTMLButtonElement | null>(null)

// トーストは見落とされやすいため、このモーダルは自動で消さず、
// 明示的な操作(ボタン/Escape/オーバーレイクリック)で閉じる仕様にする。
watch(
  () => resultModal.message,
  (msg) => {
    if (msg) {
      nextTick(() => closeBtnRef.value?.focus())
      window.addEventListener('keydown', onKeydown)
    } else {
      window.removeEventListener('keydown', onKeydown)
    }
  },
)

function onKeydown(e: KeyboardEvent) {
  if (e.key === 'Escape' || e.key === 'Enter') resultModal.close()
}
</script>

<template>
  <div v-if="resultModal.message" class="result-modal-overlay" @click="resultModal.close()">
    <div class="result-modal" :class="resultModal.type" @click.stop>
      <div class="result-modal-icon">
        <svg v-if="resultModal.type === 'ok'" class="icon" viewBox="0 0 24 24" style="width:28px;height:28px;">
          <path d="M20 6L9 17l-5-5" />
        </svg>
        <svg v-else class="icon" viewBox="0 0 24 24" style="width:28px;height:28px;">
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </div>
      <div class="result-modal-message">{{ resultModal.message }}</div>
      <button ref="closeBtnRef" class="btn btn-primary" @click="resultModal.close()">閉じる</button>
    </div>
  </div>
</template>
